import React from "react";

const CheckBoxField = (props) => {
  const AlterTextField = (e) => {
    props.ReceivedTextData({
      ...props.State,
      fieldName: e.target.name,
      fieldValue: e.target.checked,
    });
  };

  return (
    <>
      {props.type === "user" ? (
        <div className={props.classClient === true ? "input-checkbox" : ""}>
          <input
            type="checkbox"
            name={props.id}
            checked={props.value}
            disabled={props.disabled ? props.disabled : false}
            onChange={(e) => AlterTextField(e)}
          />
          <label className="input-checkbox-label">{props.label}</label>
        </div>
      ) : (
        <div className={props.classClient === true ? "input-checkbox" : ""}>
          <label className="input-checkbox-label">{props.label}</label>
          <input
            type="checkbox"
            className="ml-1"
            name={props.id}
            checked={props.value}
            disabled={props.disabled ? props.disabled : false}
            onChange={(e) => AlterTextField(e)}
          />
        </div>
      )}
    </>
  );
};

export default CheckBoxField;
